import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "../../components/PageShell";
import { MpEventsScreen } from "./MpEventsScreen";

// The page's route. Discovered by vite.config.ts because it sits in a page
// folder; PageShell applies the page's flag gate and header.
function MpEventsRoute() {
  return (
    <PageShell>
      <MpEventsScreen />
    </PageShell>
  );
}

export const Route = createFileRoute("/_app/mp-events")({
  component: MpEventsRoute,
});
